import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Img from 'gatsby-image';

const StyledNav = styled.nav`
  .navbar-brand {
    user-select: none;
    padding: 5px 15px;
    img {
      height: 45px;
    }
  }
`;
export default function Header() {
  const { t, i18n } = useTranslation();
  const [language] = (i18n.language && i18n.language.split('-')) || [];
  // async function onClick() {
  //   await navigate('/');
  // }
  const { image } = useStaticQuery(
    graphql`
        query {
            image: file(sourceInstanceName: { eq: "images" }, name:{ eq: "iop-logo"} ) {
                id
                name
                childImageSharp {
                    fixed(
                        height: 45
                    ) {
                        ...GatsbyImageSharpFixed
                    }
                }
            }
        }
    `
  );
  return (
    <StyledNav className="navbar navbar-inverse">
      <div className="container">
        <div className="navbar-header">
          <Link className="navbar-brand" to="/">
            <Img
              className="img-responsive"
              fixed={image.childImageSharp.fixed}
              alt={image.name}
            />
          </Link>
        </div>
        <div className="collapse navbar-collapse" id="navbar-collapse">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <p className="navbar-text">{t(`common.languages.${language}`)}</p>
            </li>
          </ul>
        </div>
      </div>
    </StyledNav>
  );
}
Header.propTypes = {
  data: PropTypes.shape({}),
};
